// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_full_screen-module__overlay--3DynC","container":"modal_full_screen-module__container--9lC5x","noBodyScroll":"modal_full_screen-module__noBodyScroll--1gVA0"};